import { get, includes } from 'lodash';
import { takeLatest } from 'redux-saga/effects';

import { ON_SOCKET_ACTIVITY } from 'containers/App/constants';
import { SEND_OFFER_SUCCESS } from 'containers/DialogSendOffers/constants';

import sagaRelayInvalidateData from './sagaRelayInvalidateData';

function* sagaInvalidateStore() {
  yield sagaRelayInvalidateData('Offer');
}

function* sagaOnSocketActivity(action: any) {
  const namespace = get(action, 'data.namespace');

  if (includes(['api:offers:create'], namespace)) {
    yield sagaInvalidateStore();
  }
}

export default function* sagaWatchersOffer() {
  // Invalidate data on Relay store and refetch queries
  yield takeLatest(SEND_OFFER_SUCCESS, sagaInvalidateStore);

  // Based on socket events
  yield takeLatest(ON_SOCKET_ACTIVITY, sagaOnSocketActivity);
}
